module.exports = __webpack_public_path__ + "img/BMS&EMS系统_01.89d6c3f0.png";